import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { getImageUrl } from "@/utils/imageUrl";

export function DestinationCard({ post, className = "" }) {
  const { slug, title, excerpt, featured_image_url, municipio, departamento, post_type } = post;

  const placeholderImage = "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=80";
  const imageUrl = getImageUrl(featured_image_url);

  const getUrl = () => {
    const routes = {
      destination: "/destinos",
      experience: "/experiencias",
      flavor: "/sabores",
    };
    return `${routes[post_type] || "/destinos"}/${slug}`;
  };

  const location = [municipio, departamento].filter(Boolean).join(", ");

  return (
    <Link
      to={getUrl()}
      className={`group relative h-[400px] rounded-3xl overflow-hidden isolate block ${className}`}
      data-testid={`destination-card-${slug}`}
    >
      <img
        src={imageUrl || placeholderImage}
        alt={title}
        className="absolute inset-0 w-full h-full object-cover img-zoom"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
      
      <div className="relative h-full flex flex-col justify-end p-6">
        {location && (
          <div className="flex items-center gap-1.5 text-white/80 text-sm mb-2">
            <MapPin className="h-4 w-4" />
            {location}
          </div>
        )}
        <h3 className="font-heading text-2xl font-bold text-white mb-2 group-hover:text-accent transition-colors">
          {title}
        </h3>
        {excerpt && (
          <p className="text-gray-200 text-sm line-clamp-2">{excerpt}</p>
        )}
      </div>
    </Link>
  );
}

export function DestinationCardSkeleton() {
  return (
    <div className="h-[400px] rounded-3xl bg-gray-100 animate-pulse">
      <div className="h-full flex flex-col justify-end p-6">
        <div className="h-4 w-24 bg-gray-200 rounded mb-3" />
        <div className="h-8 w-3/4 bg-gray-200 rounded mb-2" />
        <div className="h-4 w-full bg-gray-200 rounded" />
      </div>
    </div>
  );
}
